const createImgURI = (imgBase64: $TSMigrationFixMe, imgMediaType = "png") => {
  return `data:image/${imgMediaType};base64,${imgBase64}`
}

export default createImgURI
